import { ComponentElem } from "@components/interfaces";
import SearchbarPrototype, { ORDER_LIST } from "../shared/SearchbarPrototype";
import ValueSelector, { ValueSelectorResult } from "../popups/ValueSelector";
import ViewportRoot, { getViewportName } from "../../ts/sframe/ViewportRoot";
import Tools from "../../ts/Tools";
import Popups from "../popups/Popups";
import PickDateRange from "../popups/PickDateRange";
import SearchPopup from "../popups/SearchPopup";
import { Search } from "./SearchTypes";
import { Common } from "../common/CommonTypes";
import SearchManager from "./SearchManager";
import SearchResult from "./SearchResult";
import PatternSamples from "../../ts/PatternSamples";
import GS from "../../ts/GlobalSetting";

export default class SearchSearchbar extends SearchbarPrototype
{
  orderDic: any;

  _mobileKeywrodInput: HTMLInputElement;

  constructor(elem: ComponentElem)
  {
    super(elem);

    this._mobileKeywrodInput = this.$root.find(".keyword-2")[0] as HTMLInputElement;

    this._setupOrderButton();

    this.$root.find(".cover-block").on("click", (event:Event)=>
    {
      event.preventDefault();
      
      SearchPopup.instance.syncInput(SearchManager._input);
      SearchPopup.instance.toMeAsMode("default");
      
      // PickDateRange.instance.request();
    });

    this.$root.find(".btn-more-filter").on("click", (event:Event)=>
    {
      event.preventDefault();
      
      SearchPopup.instance.syncInput(SearchManager._input);
      SearchPopup.instance.toMeAsMode("extra");
    });

    this.$root.find(`.btn-reset`).on("click", (event:JQuery.ClickEvent)=>
    {
      event.preventDefault();
      // (<SearchResult>Tools.seekComponentByName("search-result")).toggle();
      SearchManager.reset();
    });

    this.orderDic = Tools.listToDic(ORDER_LIST, "value");
  }

  syncInput(input: Search.SearchInput)
  {
    this.input = Object.assign({}, input);
    delete this.input.page_index;
    this._updateOrderText();
    SearchSyncCommonInput.call(this, input);
  }

  setTotalCount(totalCount: number)
  {
    this.$root.find(".num").text(totalCount);
  }

  setMobileInputText(htmlText: string)
  {
    let $elem = $(`<div></div>`);
    $elem.html(htmlText);

    let text = $elem.text();
    this._mobileKeywrodInput.value = text;
  }

  testKeywordInput(value: string, input: Search.SearchInput)
  {
    if(value && PatternSamples["simple"].test(value) && value.length <= GS.search.keywordMaxLength) input.keyword = value;
  }

  testSortInput(value: string, input: Search.SearchInput)
  {
    let sortDic = Common.getSortDic();    
    if(sortDic[value]) input.sort = value;
  }

  testDateInput(start: string, end: string, input: Search.SearchInput)
  {
    if(start && end)
    {
      //@ts-ignore
      let startDate = moment(start);
      //@ts-ignore
      let endDate = moment(end);

      if(startDate.isValid() && endDate.isValid)
      {
        input.start_date = start;
        input.end_date = end;
      }
    }
  }

  testOrderInput(value: string, input: Search.SearchInput)
  {
    let dic = Tools.listToDic(ORDER_LIST, "value");
    if(dic[value]) input.order = value;    
  }

  _updateOrderText()
  {
    this.$root.find(".order-text").text(this.orderDic[this.input.order].text);
  }

  _setupOrderButton()
  {
    let $btn = this.$root.find(".btn-change-order");
    $btn.on("click", (event: JQuery.ClickEvent) =>
    {
      event.preventDefault();

      let trigger = getViewportName() === "mobile" ? undefined : $btn[0];


      ValueSelector.instance.show(ORDER_LIST, trigger).then((result?: ValueSelectorResult) =>
      {
        if(result)
        {
          let oldValue = this.input.order;
          this.input.order = result.value;
          if (this.input.order !== oldValue) {
            this._updateOrderText();
            this.emitter.emit("change", "order");
          }
        }
      });
    });
  }
}

/**
 * Update input based on props value.
 * 搜尋input參數帶入
 * 
 * ```javascript
 * const input = {
 *   keyword: 'example',
 *   sort: 'date',
 *   start_date: '2022-01-01',
 *   end_date: '2022-01-31'
 * };
 * SearchSyncCommonInput(input);
 * ```
 * 
 * @param {Object} searchInput - The input object containing search parameters.
 * @param {string} searchInput.keyword - The keyword for the search.
 * @param {string} searchInput.sort - The sorting criterion.
 * @param {string} searchInput.start_date - The start date for the search range.
 * @param {string} searchInput.end_date - The end date for the search range.
 */
export function SearchSyncCommonInput(input: Search.SearchInput)
{
  this._keywordInputElem.value = input.keyword === undefined? "": input.keyword;

  this._sortInputElem.value = input.sort? input.sort: "";

  if(input.start_date && input.end_date)
  {
    ///@ts-ignore
    this.startDate = moment(input.start_date);
    ///@ts-ignore
    this.endDate = moment(input.end_date);
  }
  else
  {
    this.startDate = undefined;
    this.endDate = undefined;
  }

  this._updateDateText();   
}